import React from "react";
import "./App.css";
import Advice from "./Advice";

function App() {
  return (
    <div className='App'>
      <Advice />
    </div>
  );
}

export default App;
